<template>
  <b-container class="my-auto pt-5">
    <b-jumbotron class="shadow p-5 mb-5 bg-white rounded mx-auto w-50 text-center">
      <h4 class="display-4 my-2"><small v-html="siteName"></small></h4>
      <label class="text-danger mb-4" v-html="loginError || '&nbsp'"></label>
      <b-form>
        <b-form-group id="input-group-1">
          <b-form-input
            id="input-2"
            v-model="form.username"
            required
            placeholder="Username"
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2">
          <b-form-input
            id="input-2"
            type="password"
            v-model="form.password"
            required
            placeholder="Password"
          ></b-form-input>
        </b-form-group>

        <b-button class="mx-auto w-25" @click="login" variant="primary">Login</b-button>
      </b-form>
    </b-jumbotron>
  </b-container>
</template>

<script>
  import Config from '../../config'
  export default {
    name : `LoginPage`,
    data() {
      return {
        form: {
          username: '',
          password: '',
        },
        loginError : null
      }
    },
    computed: {
      token() {
        return this.$store.getters['user/token']
      },
      siteName(){
        return Config.siteName || `PhilPsyCor Online Test`
      }
    },
    methods: {
      login(){
        this.loginError = null
        const {username, password } = this.form
        this.$store.dispatch(`user/login`, {username, password}).then(() => {
          const role = this.$store.getters[`user/role`]
          if(role === `examinee`){
            this.$router.push(`/examinee/termsandconditions`)  
          }
          else{
            this.$router.push(`/${role}`)
          }
        })
        .catch(err => this.loginError = err.message)
      },
    }
  }
</script>

<style scoped>

</style>